<template>
  <div
    class="basic_product_display_index"
    @mouseenter="module_isHover(true)"
    @mouseleave="module_isHover(false)"
  >
    <div class="tooptipPart module_edit_btn" v-if="isHover">
      <my_hover_btn :tips="$t('widgets_basic_article_classification_index_336')" btnIcon="el-icon-edit" @changeStyle="edit_module"></my_hover_btn>
      <my_hover_btn
        :tips="$t('widgets_basic_article_classification_edit_330')"
        btnIcon="el-icon-magic-stick"
        @changeStyle="animation_set"
        v-if="$store.state.app.view_pattern === 'pc'"
      ></my_hover_btn>
      <my_hover_btn
        :tips="$t('components_basic_addproduct_index_2078')"
        btnIcon="el-icon-menu"
        @changeStyle="add_content"
        v-if="$store.state.app.view_pattern === 'pc' && !isSystem && !(listArr.type_system !== undefined && ['article', 'help', 'case', 'product'].includes(this.$route.name))"
      ></my_hover_btn>
      <my_close_btn :module="module" :column="column" :moduleIndex="module_index"
                    v-if="$store.state.app.view_pattern === 'pc' && !isSystem"></my_close_btn>
    </div>
    <div class="basic_product_display">
      <my_title_index :title="pc_infor.title" v-show="isPc"></my_title_index>
      <my_title_index :title="mb_infor.title" v-show="!isPc"></my_title_index>
      <div class="module_wrap" :class="`module_wrap_${listArr.module_style == 4 ? 1: listArr.module_style} module_wrap_${listArr.module_style}`">
        <basic_addProduct
          v-if="add_Product_isShow"
          @closed="add_Product_close"
          @submit_sure="submit_sure"
        ></basic_addProduct>
        <!-- 搜索条件 -->
        <div class="search_condition" v-if="isSystem">
          <cur_condition :typeName="typeName" :module="module" @delType="delType" @searchPro="searchPro"></cur_condition>
               
          <div class="jz_empty_tips" v-if="list.length == 0">
            <i class="jz_empty_tips__img"></i>
            <div class="jz_empty_tips__text">{{$t('widgets_basic_product_display_index_2787')}}</div>
          </div>
        </div>
        <div
          class="empty"
          v-if="list.length == 0 && !isSystem && $store.state.app.view_pattern === 'pc'"
          >
           <!-- 直接添加 -->
          <div v-if="listArr.type == 'system'">
            <selection_prompt type="goodsList" :ids.sync="listArr.system" select-type="label"></selection_prompt>
          </div>
          <!-- 标签添加的判断 -->
          <div v-if="listArr.type == 'label'">
            <!-- 暂无产品数 -->
            <selection_prompt type="goodsList" :ids.sync="listArr.label" select-type="label"></selection_prompt>
          </div>
          <!-- 直接添加 -->
          <div v-if="listArr.type == 'custom'">
            <selection_prompt
              type="goodsList"
              :ids.sync="listArr.custom"
              @add_content="add_content"
            ></selection_prompt>
          </div>
          <!-- 筛选条件 -->
          <div v-if="listArr.type == 'systom'">
            <selection_prompt type="goodsList" action="class" @select_class="select_class"></selection_prompt>
          </div>
        </div>
        <my_mb_empty_tips
          v-if="list.length <= 0 && !isSystem && $store.state.app.view_pattern === 'mb'"
          :tip="$t('widgets_basic_classification_edit_482')"
        ></my_mb_empty_tips>

        <div class="cate_summary condition-cate-summary" v-html="typeCont.content_top" v-show="isPc" v-if="isSystem && pc_infor.cate_cont_show === 'true'"></div>

        <div class="module_content" v-loading="loading" v-if="list.length > 0">
          <!-- 第一种模式 -->
          <template v-if="listArr.module_style == 0">
            <div class="product_list_0">
              <one_img
                v-for="(item,i) in list"
                :key="i"
                :item="item"
                :module="module"
                :hideBtn="hideBtn"
                @getProduct="getProduct"
              ></one_img>
            </div>
          </template>
          <!-- 第二种轮播图模式 -->
          <template v-if="listArr.module_style == 1 || listArr.module_style == 4">
            <!-- pc模式 -->
            <template v-if="!($store.state.app.view_pattern == 'mb' && listArr.module_style == 1)">
              <span
              @click="templet.is_jump({href:`${routerType}?id=${productDetail.goods_id}&tag_id=${productDetail.tag_ids}`,target:pc_infor.target})"
              class="product_detail" v-if="listArr.module_style == 4 && $store.state.app.view_pattern == 'pc'">
                <div class="list_one">
                    <div class="list_img_frame">
                      <div class="list_img"
                        :style="{
                          backgroundImage:productDetail.img !== '' ?'url('+ productDetail.img +')':'url(/static/image/noimage.jpg)'
                        }">
                        <img
                          :src="productDetail.img !== '' ? productDetail.img : '/static/image/noimage.jpg'"
                          :alt="productDetail.name"
                          :title="productDetail.name" style="width: 100%; height: 100%; object-fit: cover;opacity: 0;">
                      </div>
                  </div>
                </div>
                <div class="product_detail_left">
                  <component :is="isSystem ? 'h2' : 'p'" class="detail_name" :style="pro_name_font">{{productDetail.name}}</component>
                  <p class="detail_summary" :style="pro_summary_font">{{productDetail.summary}}</p>
                  <detail_button :item="productDetail" :module="module" v-if="!pc_infor.button_text.isHidden"></detail_button>
                </div>
             </span>
              <div class="product_list_1" :style="{
                padding: list.length > pc_infor.col_num[pc_infor.col_num.radio_val].value ? '0 60px' : ''
              }">
                <swiper
                  ref="mySwiper"
                  class="list_box"
                  :options="swiperOption"
                  v-if="$store.state.app.basic_pro_display_isRender ? $store.state.app.view_pattern == 'pc' && listArr.module_style == 4 && list.length == 1 ? false : true: false"
                >
                  <swiper-slide v-for="(item,i) in list" :key="i"> 
                    <one_img
                    :class="listArr.module_style == 4 && i == selectIndex ? 'select-product' : ''"
                      :item="item"
                      :module="module"
                      :hideBtn="hideBtn"
                      @click_product="click_product(i)"
                      @getProduct="getProduct"
                      type="swiper"
                    ></one_img>
                  </swiper-slide>
                </swiper>

                <template v-if="$store.state.app.view_pattern == 'mb' && list.length > 1
                  || $store.state.app.view_pattern == 'pc' && list.length > pc_infor.col_num[pc_infor.col_num.radio_val].value">
                  <div class="arrow prev" @click="swiper_prev"></div>
                  <div class="arrow next" @click="swiper_next"></div>
                </template>
              </div>
              <router-link 
              :to="`${routerType}?id=${productDetail.goods_id}&tag_id=${productDetail.tag_ids}`"
              :target="pc_infor.target" class="product_detail" v-if="listArr.module_style == 4 && $store.state.app.view_pattern == 'mb'">
                <div class="product_detail_left">
                  <component :is="isSystem ? 'h2' : 'p'" class="detail_name" :style="pro_name_font">{{productDetail.name}}</component>
                  <p class="detail_summary" :style="pro_summary_font">{{productDetail.summary}}</p>
                  <detail_button :item="productDetail" :module="module" v-if="!pc_infor.button_text.isHidden"></detail_button>
                </div>
              </router-link>
            </template>

            <template v-else>
              <div class="list_box flex_box mb_swiper_list">
                <one_img
                  v-for="(item,i) in list"
                  :key="i"
                  :item="item"
                  :module="module"
                  :hideBtn="hideBtn"
                  @getProduct="getProduct"
                ></one_img>
              </div>
            </template>
          </template>
          <!-- 第三种左图右文 -->
          <template v-if="listArr.module_style == 2">
            <div class="product_list_2">
              <one_img
                v-for="(item,i) in list"
                :key="i"
                :item="item"
                :module="module"
                :hideBtn="hideBtn"
                @getProduct="getProduct"
              ></one_img>
            </div>
          </template>
          <!-- 第四种只有文字 -->
          <template v-if="listArr.module_style == 3">
            <div class="product_list_3">
              <one_img
                v-for="(item,i) in list"
                :key="i"
                :item="item"
                :module="module"
                :hideBtn="hideBtn"
                @getProduct="getProduct"
              ></one_img>
            </div>
          </template>
          <my_page_index
            v-if="pc_infor.page.radioValue && list.length > 0 && listArr.module_style !== 1 && listArr.module_style !== 4"
            :page="pc_infor.page"
            :currentPage.sync="currentPage"
            :total="total"
            @change-page="changePage"
          ></my_page_index>
        </div>

        <div class="cate_summary condition-cate-summary" v-html="typeCont.content" v-show="isPc" v-if="isSystem && pc_infor.cate_cont_show === 'true'"></div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

import selection_prompt from '@/components/selection_prompt';
import one_img from "./components/one_img";
import cur_condition from "./components/cur_condition";
import {box_shadow_style_add, getBackgroundData, getSwiperSettingData, fontSet,basic_product_display_new_style, getCommonStyle} from "@/base/widgets_data_compatible";
import detail_button from "./components/detail_button";
import {detail_button_style} from '@/base/base'
import {font_set} from '@/base/background_set';

export default {
  name: 'basic_product_display_index',
  components: {
    selection_prompt,
    one_img,
    cur_condition,
    detail_button
  },
  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    }
  },
  computed: {
    routerType() {
      return `#/product`
    },
    pcInforFont() {
      return this.pc_infor.product_name_font[this.pc_infor.product_name_font.radio_val]
    },
    pro_name_font() {
      return this.fromTag !== 'search'? font_set(this.pc_infor.product_name_font): ''
    },
    pro_summary_font() {
      if(this.fromTag !== 'search'){
        let font =  font_set(this.pc_infor.product_name_font)
        font.fontSize = (this.pcInforFont.fontSize - 2) + 'px'
        font.fontWeight = 'normal'
        font.textDecoration = 'normal'
        font.fontStyle = 'normal'
        font.opacity = 0.8
        return font
      }else{
        return '';
      }
    },
    productDetail() {
      return this.list.length > 0 && this.module.data.listArr.module_style == 4 ? this.list[this.selectIndex]: {}
    },
    listArr() {
      return this.module.data.listArr
    },
    mb_infor() {
      return this.module.data.mb_widgets_infor
    },
    pc_infor() {
      return this.module.data.pc_widgets_infor
    },
    widgets_infor() {
      return this.module.data[this.$store.state.app.view_pattern + "_widgets_infor"];
    },
    swiperOption() {
      const infor = this.module.data.pc_widgets_infor;
      const num = this.$store.state.app.view_pattern == 'pc' ? parseInt(infor.col_num[infor.col_num.radio_val].value) : 1;
      const slidesPerGroup = this.$store.state.app.view_pattern == 'pc' ? parseInt(infor.slides_group[infor.slides_group.radio_val].value) : 1;
      const loop = infor.swiper_loop === 'true' ? true : false
      const obj = {
        myVm: this,
        loop: slidesPerGroup == 1 ? loop : false,
        direction: "horizontal",
        slidesPerView: num,
        slidesPerGroup,//每次翻页个数
        observer: true,
        observeParents: true,
      }
      const autoplay = this.templet.autoplay_obj(
        infor.banner_set,
        obj
      );
      obj.autoplay = autoplay;
      return obj;
    },
    isPc() {
      return this.$store.state.app.view_pattern === "pc";
    },
    // 分类简介
    typeCont(){
      let cont = '';
      if(this.proTypeId){
        let proTypeList = this.$store.state.app.proTypeList
        console.log('proTypeList123', proTypeList);
        
        for (let i = 0; i < proTypeList.length; i++) {
          if(this.proTypeId == proTypeList[i].id){
            cont = proTypeList[i]
          }
        }
      }
      return cont;
    }
  },
  watch: {
    'listArr.module_style'(val) {
      if(val == 4) {
        this.pc_infor.img_size.custom.height = '100%'
        this.pc_infor.col_num.custom.value = 4
      }
    },
    '$store.state.myRender.common.theme_color'(val) {
      const fontSize = this.pc_infor.product_name_font[this.pc_infor.product_name_font.radio_val].fontSize
      const buttonStyle = detail_button_style(this.pc_infor.button_text.styleType,val,fontSize)
      this.$set(this.pc_infor.button_text, "buttonStyle", buttonStyle);
    },
    'pc_infor.button_text.styleType'(val) {
      const fontSize = this.pc_infor.product_name_font[this.pc_infor.product_name_font.radio_val].fontSize
      const theme_color = this.$store.state.myRender.common.theme_color
      const buttonStyle = detail_button_style(this.pc_infor.button_text.styleType,theme_color,fontSize)
      this.$set(this.pc_infor.button_text, "buttonStyle", buttonStyle);
    },
    listArr: {
      handler: function (val) {
        this.page_reset();
        this.templet.get_product(this);
      },
      deep: true
    },
    "pc_infor.page": {
      handler: function (val) {
        this.page_reset();
        this.templet.get_product(this);
      },
      deep: true
    },
    "pc_infor.showNum": {
      deep: true,
      handler(val) {
        this.page_reset();
        this.templet.get_product(this);
      }
    },
    "pc_infor.showAll": {
      deep: true,
      handler(val) {
        this.page_reset();
        this.templet.get_product(this);
      }
    }
  },
  data() {
    return {
      isHover: false,
      add_Product_isShow: false,
      isReset: false,
      list: [],
      selectIndex: 0,
      loading: false,
      currentPage: 1,
      total: 0,
      proTypeId: this.$route.query.id !== undefined ? this.$route.query.id : '',
      typeName: this.$route.query.name !== undefined ? this.$route.query.name : '',
      keyword: '',
      isSystem: this.module.data.isSystem === 'true' ? true : false,
      hideBtn: false
    };
  },
  created() {
    this.templet.checkShowValue(this.module.data.pc_widgets_infor);
    this.fixFields()
    if(this.listArr.module_style == 4) {
      this.pc_infor.img_size.custom.height = '100%'
      this.pc_infor.col_num.custom.value = 4
    }
    if(this.module.widgets_id > 1000000 && ['article', 'help', 'case', 'product'].includes(this.$route.name) && this.listArr.type_system !== undefined){
        this.pc_infor.title.text.value = 'Recommend'
        this.pc_infor.title.text.isHidden = false
        this.mb_infor.title.text.value = 'Recommend'
        this.mb_infor.title.text.isHidden = false        
    }
  },
  mounted() {
    this.templet.get_product(this);
  },
  methods: {
    // 是否是系统推荐
    isSystemRecommend() {

    },
    click_product(i) {
      this.selectIndex = i
    },
    /* 删除分类*/
    delType(val) {
      this.proTypeId = ''
      this.searchPro(val)
    },
    /* 模糊搜索*/
    searchPro(val) {
      this.keyword = val
      this.page_reset()
      this.templet.get_product(this);
    },
    getProduct() {
      this.page_reset()
      this.templet.get_product(this);
    },
    /* 是否显示tooptipPart*/
    module_isHover(val) {
      this.isHover = val;
    },
    /* 编辑模块*/
    edit_module() {
      this.templet.changeStyle(this.module, 'style');
    },
    /* 动画设置*/
    animation_set() {
      this.templet.changeStyle(this.module, 'animation');
    },
    /* 删除模块*/
    del_module() {
      this.templet.del_module(this.column.widgets_id, this.module_index, this.module.data.anchor_id);
    },
    /* 选择产品*/
    add_content() {
      this.add_Product_isShow = true
    },
    /* 关闭新增产品窗口*/
    add_Product_close() {
      this.add_Product_isShow = false
    },
    /* 新增产品，确定按钮*/
    submit_sure(val) {
      // this.add_Product_close();
      this.listArr.custom.push(val)
    },
    /* 上一个*/
    swiper_prev() {
      this.$refs.mySwiper.swiper.slidePrev();
      if(this.listArr.module_style == 4 && this.$store.state.app.view_pattern == 'mb') {
        this.selectIndex = this.$refs.mySwiper.swiper.activeIndex
      }
    },
    /* 下一个*/
    swiper_next() {
      this.$refs.mySwiper.swiper.slideNext();
      if(this.listArr.module_style == 4 && this.$store.state.app.view_pattern == 'mb') {
        this.selectIndex = this.$refs.mySwiper.swiper.activeIndex
      }
    },
    //选择分类
    select_class() {
      this.listArr.type = "systom";
      this.templet.changeStyle(this.module);
    },
    /* 重置分页*/
    page_reset() {
      //this.list = [];
      this.isReset = true
      this.currentPage = 1;
      this.total = 0;
    },
    changePage(val) {
      this.currentPage = val
      this.templet.get_product(this);
    },
    fixFields() {
      //搜索是否开启 兼容处理
      if (typeof this.pc_infor.search_is_open == 'undefined') {
        this.$set(this.pc_infor, 'search_is_open', 'true');
      }
      if (!this.pc_infor.background) {
        this.$set(this.pc_infor, "background", getBackgroundData().background);
      }
      if (!this.pc_infor.slides_group) {
        this.$set(this.pc_infor, "slides_group", getSwiperSettingData().slides_group);
        this.$set(this.pc_infor, "swiper_loop", getSwiperSettingData().swiper_loop);
        this.$set(this.pc_infor, "banner_set", getSwiperSettingData().banner_set);
      }
      if (this.module.data.isSystem === 'true') {
        this.module.data.listArr.type = 'all'
      }
      // 兼容处理
      if (this.module.data.listArr.sortBy === 'sort') {
        this.module.data.listArr.sortBy = 'default'
      }
      // 4.6.7 组合阴影
      if (typeof this.pc_infor.boxShadow == "undefined") {
        this.$set(this.pc_infor, "boxShadow", box_shadow_style_add().boxShadow);
      }
      // 4.3.16 产品_name的颜色
      if(typeof this.pc_infor.product_name_font == "undefined"){
        this.$set(this.pc_infor, 'product_name_font', fontSet())
        // this.$set(this.pc_infor, 'product_name_font', font_set_add())
      }else{
        // 4.7.12 兼容数据        
        if(typeof this.pc_infor.product_name_font.default == "undefined") {            
            let font_set = fontSet()
            let custom_val = this.pc_infor.product_name_font.custom
            for (const key in font_set.custom) {                
                if(custom_val[key]){
                  font_set.custom[key] = custom_val[key]
                }
            }
            font_set.radio_val = 'custom'
            this.$set(this.pc_infor, 'product_name_font', font_set)
        }
      }

      // 4.7.15
      if(typeof this.pc_infor.cate_cont_show == "undefined"){
        this.$set(this.pc_infor, 'cate_cont_show', 'true')
      }
      
      // 组合背景 这边颜色 添加悬浮的颜色  首先悬浮颜色 应该只有背景色才会有 是图片的时候不能存在 
      if(this.pc_infor.background && !this.pc_infor.background.default.seColor) { // 组合背景存在 并且没有 悬浮的样式 才进行操作
        //  所以 在预览的时候要进行处理 background 不存在的情况 以及 没有seColor 和 存在seColor的情况
        this.$set(this.pc_infor.background.default, "seColor",this.pc_infor.background.default.color);
        this.$set(this.pc_infor.background.custom, "seColor",this.pc_infor.background.custom.color);
      }
      const fontSize = this.pc_infor.product_name_font[this.pc_infor.product_name_font.radio_val].fontSize || 16
      const theme_color = this.$store.state.myRender.common.theme_color
      let button_text = basic_product_display_new_style().button_text
      const buttonStyle = detail_button_style(button_text.styleType,theme_color,fontSize)
      if (typeof this.pc_infor.button_text == 'undefined' || typeof this.pc_infor.button_text.buttonStyle == 'undefined') {
        button_text.buttonStyle = buttonStyle
        this.$set(this.pc_infor, 'button_text', button_text);
      }
      // 圆角
      if (typeof this.pc_infor.borderRadius == "undefined") {
        this.$set(this.pc_infor, "borderRadius", getCommonStyle().borderRadius);
      }

    }
  }
};
</script>

<style lang="scss" scoped>
.basic_product_display_index {
  position: relative;
  box-sizing: border-box;
  min-height: 30px;
  min-width: 30px;
  height: 100%;

  .tooptipPart {
    right: 0;
    top: 0;
    display: block;
    z-index: 999;
  }
}

.flex_box {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}

.basic_product_display {
  .textEdit {
    display: block;
    width: 100%;
    cursor: text;
    min-width: 10px;
    overflow: hidden;
    pointer-events: none;
  }
}

.pc_pattern .module_wrap {
  padding-top: 20px;
}

.mb_pattern {
  .module_wrap_0, .module_wrap_1 {
    padding-top: 28px;
  }

  .module_wrap_1 {
    padding-top: 18px;
  }
}

.module_wrap {
  .module_content {
    position: relative;
    font-size: 14px;

    .product_list_0 {
      display: flex;
      flex-wrap: wrap;
      align-items: stretch;

      /deep/ .list_one {
        height: auto !important;
      }
    }

    .product_list_2 {
      /deep/ .list_one {
        width: calc(100% - 20px);
        padding: 20px;
        // margin: 20px 10px;
        margin: 10px 0;
        overflow: visible;
        display: flex;

        &:not(:last-child):after {
          content: "";
          width: 100%;
          height: 0;
          border-bottom: 1px dashed #f0f0f0;
          display: block;
          position: absolute;
          bottom: -6px;
          left: 0;
        }

        .list_content_frame {
          float: left;
          margin-left: 20px;
          width: calc(75% - 20px);
          text-align: left;
        }
      }

      /deep/ .list_img_frame {
        width: 25%;
        padding-bottom: 25%;
        float: left;
      }

      /deep/ .list_one_wrap {
        display: block;
        height: 100%;
        color: #333;
        // padding: 0;
        padding: 10px 10px;
        overflow: visible;
      }
    }

    .product_list_3 {
      /deep/ .list_one {
        text-align: left;
        border: 1px solid #f0f0f0;
        border-radius: 2px;
        transition: none;
        padding: 0;
        /* box-shadow: 0 0 15px rgb(0 0 0 / 10%); */
      }

      /deep/ .list_one_wrap {
        position: relative;
        transition: 0.5s;

        .product_name_wrap {
          margin-bottom: 0 !important;
          margin-top: 0 !important;

          .product_name {
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            display: inline-block;
            max-width: 100%;
          }
        }
      }

      /deep/ .list_img_frame {
        display: none;
      }
    }

    .product_list_1 {
      position: relative;

      .list_box {
        .swiper-wrapper {
          .swiper-slide {
            height: auto;

            .list_one {
              height: 100%;
              padding: 10px;
              margin: 0 !important;
              width: 100% !important;
            }
          }
        }
      }

      .arrow {
        cursor: pointer;
        display: block;
        width: 40px;
        height: 40px;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;
        position: absolute;
        z-index: 99;
        top: 50%;
        transform: translateY(-50%);
        background: rgba(0, 0, 0, 0.2);
        transition: background 0.15s;
        outline: 0;
      }

      .arrow:before {
        content: "";
        position: absolute;
        display: block;
        width: 10px;
        height: 18px;
        background: url("/static/image/backimg1.png") -23px -268px;
        top: 50%;
        left: 50%;
        transform: translate(-50%) translateY(-50%);
      }

      .prev {
        left: 10px;
      }

      .next {
        right: 10px;
      }

      .next:before {
        background-position-x: -53px;
        left: 54%;
      }
    }
  }
  .search_condition{
    .cate_summary{
      font-size: 14px;
      padding: 10px 0px 0px 10px;
    }
  }
}

.mb_pattern {
  .basic_product_display_index {
    .product_list_0,
    .product_list_1,
    .product_list_2,
    .mb_swiper_list {
      padding: 0 1.8%;
      width: auto;
    }
  }
}

.mb_pattern {
  .basic_product_display_index {
    /deep/ .list_content_frame {
      text-align: left;
      margin: 6px;

      .product_name_wrap {
        margin-top: 0 !important;
        margin-bottom: 5px !important;

        .product_name {
          // font-size: 14px !important;
        }
      }
    }

    .mb_swiper_list {
      width: 100%;
      display: block;
      overflow-x: auto;
      white-space: nowrap;

      /deep/ .list_one {
        width: 45%;
        text-align: left;
        padding: 10px;
        margin: 0 !important;

        .list_one_wrap {
          padding: 0;
        }
      }
    }

    .mb_swiper_list::-webkit-scrollbar {
      height: 0px;
    }

    .product_list_0 {
      /deep/ .list_one_wrap {
        padding: 0;
      }
    }

    .product_list_2 {
      /deep/ .list_one {
        padding: 0;
        margin: 10px;
        overflow: visible;
        box-sizing: content-box;

        .list_img_frame {
          width: 33.8%;
          padding-bottom: 33.8%;
          float: left;
        }

        .product_name_wrap {
          margin: 6px !important;
        }

        .list_content_frame {
          width: 66.2%;
          display: inline-block;
          float: none;
          margin: 0;
          box-sizing: border-box;
          padding-left: 12px;
        }
      }
    }

    .product_list_3 {
      margin-top: 0;

      /deep/ .list_one {
        text-align: left;
        width: 100%;
        border: none;
        margin: 0;
        padding: 15px;
        border-bottom: 1px solid #f1f1f1;

        .list_one_wrap {
          padding: 0;
        }

        .list_content_frame {
          margin: 0;
        }
      }
    }
  }
}

.mb_pattern .module_wrap_2 {
  padding-top: 0;
}
.product_detail {
  display: flex;
  margin-bottom: 20px;
  .product_detail_left {
    margin: 0 10px;
    padding-top: 10px;
    flex: 1;
    .detail_name {
      margin-top: 0;
      margin-bottom: 15px;
      font-weight: 400;
    }
    .detail_summary{
      margin-bottom: 15px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 8;
      -webkit-box-orient: vertical;
    }
  }
  .list_one {
    height: 100%;
    width: 40%;
    padding: 10px;
      .list_img_frame {
        position: relative;
        padding-bottom: 100%;
        overflow: hidden;
        .list_img {
          border: 1px solid #eee;
          position: absolute;
          width: 100%;
          height: 100%;
          cursor: pointer;
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
        }
    }
  }
}
.mb_pattern .basic_product_display .module_wrap_4 {
  padding-top: 0 !important;
  .product_list_1 {
    padding: 0 !important;
    /deep/ .list_one{
      padding: 0 !important;
      .list_one_wrap{
        padding: 0 !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_product_display/index.vue